import { v4 as uuidv4 } from 'uuid'

export const addIDForTheList = (arr) => {
    let finalArray = []
    arr.forEach(e => {
        e.id = uuidv4();
        finalArray.push(e)
    });
    return finalArray
}